/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b0e283b3a840bc3b4c203e922f72a6c>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ProblemIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m3.964 2.904 9.132 9.132a6.501 6.501 0 0 0-9.132-9.132m8.072 10.192L2.904 3.964a6.501 6.501 0 0 0 9.132 9.132M2.343 2.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 2.343" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ProblemIcon.displayName = 'ProblemIcon';
var _default = exports.default = ProblemIcon;